import ICloudButton from './ICloudButton'

export default ICloudButton
